<template>
	<div class="page" v-if="page">
		<section class="section">
			<div class="container is-fullhd">
				<div class="box is-hidden-mobile">
					<div class="columns is-variable is-6 has-separators">
						<div class="column">
							<TeamPageSummary v-if="page" :page="page" />
						</div>
						<div class="column">
							<Chart v-if="chart_roster_position_summary" :config="chart_roster_position_summary" />
						</div>
						<div class="column">
							<TeamPageRoster v-if="page" :page="page" />
						</div>
					</div>
				</div>

				<div class="is-hidden-tablet">
					<div class="box">
						<TeamPageSummary v-if="page" :page="page" />
					</div>

					<Chart v-if="chart_roster_position_summary" :config="chart_roster_position_summary" />

					<div class="box">
						<TeamPageRoster v-if="page" :page="page" />
					</div>
				</div>
			</div>
		</section>

		<section class="section is-hidden-mobile">
			<div class="container is-fullhd">
				<div class="content">
					<div class="is-flex is-flex-apart">
						<h2>Roster Performance</h2>

						<Dropdown
							:options="page.graph_datas.roster_position_weeks"
							:optionText="(option) => option.roster_position"
							:handleSelectedOption="setSelectedRosterPositionForWeekChart"
						/>
					</div>

					<Chart v-if="chart_roster_position_weeks" :config="chart_roster_position_weeks" />
				</div>
			</div>
		</section>

		<section class="section">
			<div class="container content is-fullhd">
				<TeamPageSchedule v-if="page" :page="page" />
			</div>
		</section>

		<section class="section">
			<div class="container content is-fullhd">
				<TeamPageAlternateSchedules v-if="page" :page="page" />
			</div>
		</section>
	</div>
</template>

<script>
import Chart from "@/components/Chart"
import Dropdown from "@/components/Dropdown"
import TeamPageAlternateSchedules from "@/components/TeamPageAlternateSchedules"
import TeamPageRoster from "@/components/TeamPageRoster"
import TeamPageSchedule from "@/components/TeamPageSchedule"
import TeamPageSummary from "@/components/TeamPageSummary"

export default {
	components: {
		Chart,
		Dropdown,
		TeamPageAlternateSchedules,
		TeamPageRoster,
		TeamPageSchedule,
		TeamPageSummary,
	},
	data() {
		return {
			selectedRosterPositionForWeekChart: 0,
		}
	},
	computed: {
		page() {
			return this.$store.getters.activePage
		},
		chart_roster_position_summary() {
			return !this.page
				? null
				: {
						type: "bar",
						height: 500,
						series: this.page.graph_datas.roster_position_summary.series,
						options: {
							plotOptions: {
								bar: {
									horizontal: true,
									columnWidth: "55%",
									dataLabels: {
										position: "bottom",
									},
								},
							},
							dataLabels: {
								enabled: true,
								textAnchor: "start",
								style: {
									colors: ["#fff"],
								},
								formatter: (value, data) =>
									(data.seriesIndex == 0 && this.page.graph_datas.roster_position_summary.ranks[data.dataPointIndex]) ||
									"",
								offsetX: -15,
								dropShadow: {
									enabled: true,
								},
							},
							stroke: {
								show: true,
								width: 2,
								colors: ["transparent"],
							},
							xaxis: {
								categories: this.page.graph_datas.roster_position_summary.labels,
							},
							yaxis: {
								min: 0,
								max: this.page.graph_datas.roster_position_summary.max_value,
							},
							fill: {
								opacity: 1,
							},
						},
				  }
		},
		roster_position_weeks_data() {
			return this.page &&
				this.selectedRosterPositionForWeekChart >= 0 &&
				this.selectedRosterPositionForWeekChart < this.page.graph_datas.roster_position_weeks.length
				? this.page.graph_datas.roster_position_weeks[this.selectedRosterPositionForWeekChart]
				: null
		},
		chart_roster_position_weeks() {
			return !this.roster_position_weeks_data
				? null
				: {
						type: "line",
						height: 400,
						series: this.roster_position_weeks_data.series,
						options: {
							dataLabels: {
								enabled: false,
							},
							stroke: {
								curve: "smooth",
							},
							markers: {
								size: 6,
							},
							xaxis: {
								categories: this.roster_position_weeks_data.labels,
							},
							yaxis: {
								title: {
									text: "Points",
								},
							},
							legend: {
								position: "right",
							},
						},
				  }
		},
		selectedRosterPositionNameForWeekChart() {
			return this.roster_position_weeks_data.roster_position || ""
		},
	},
	methods: {
		setSelectedRosterPositionForWeekChart(rosterPositionForWeekChart) {
			this.selectedRosterPositionForWeekChart = rosterPositionForWeekChart
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "team_dashboard")
	},
}
</script>

<style scoped>
.columns.has-separators > .column:not(:last-child) {
	position: relative;
}

.columns.has-separators > .column:not(:last-child):after {
	border-right: 1px solid rgba(0, 0, 0, 0.05);
	bottom: 1rem;
	content: "";
	display: block;
	position: absolute;
	right: 0;
	top: 1rem;
}
</style>
